import React from "react";

export default function SupplyType({
  supplyTypes,
  checkedSupplyTypes,
  setCheckedSupplyTypes,
}) {
  const handleCheckbox = (obj) => {
    if (!checkedSupplyTypes.find((s) => s.id === obj.id)) {
      setCheckedSupplyTypes([obj, ...checkedSupplyTypes]);
    } else {
      setCheckedSupplyTypes(
        [...checkedSupplyTypes].filter((s) => s.id !== obj.id)
      );
    }
  };

  return supplyTypes ? (
    <div className="content-container">
      <div className="supply-check">
        <ul>
          {supplyTypes.map((prop) => {
            return (
              <li key={prop.id}>
                <span
                  onClick={() => {
                    handleCheckbox({ id: prop.id, name: prop.name });
                  }}
                >
                  <input
                    checked={checkedSupplyTypes.find((s) => s.id === prop.id)}
                    type="checkbox"
                    onChange={() => {
                      handleCheckbox({
                        id: prop.id,
                        name: prop.name,
                        display_name: prop.display_name,
                      });
                    }}
                    name={prop.name}
                    key={prop.id}
                  ></input>
                  <label>{prop.display_name}</label>
                </span>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  ) : null;
}
